import * as React from "react";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import { Button } from "../ui/button";
import { canUseWidget, WIDGET_REGISTRY, WidgetType } from "./widgetRegistry";

interface IProps {
  placedTypes: string[];
  onAdd(type: WidgetType): void;
}

// Floating dock centred at the bottom of the screen while customising the dashboard
const AddWidgetList = ({ placedTypes, onAdd }: IProps) => {
  const { t } = useTranslation();

  const available = (Object.keys(WIDGET_REGISTRY) as WidgetType[]).filter(
    (type) => canUseWidget(type) && !placedTypes.includes(type)
  );

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-6 z-40 flex justify-center px-4">
      <div className="pointer-events-auto flex max-w-full items-center gap-3 rounded-xl border bg-background p-2 shadow-lg">
        <span className="shrink-0 pl-2 text-sm font-medium">{t("Dashboard::Add widget")}</span>
        {available.length === 0 ? (
          <span className="pr-2 text-sm text-muted-foreground">
            {t("Dashboard::All available widgets are on your dashboard")}
          </span>
        ) : (
          <div className="flex min-w-0 gap-2 overflow-x-auto">
            {available.map((type) => (
              <Button
                key={type}
                type="button"
                variant="outline"
                className="shrink-0"
                onClick={() => onAdd(type)}
              >
                <Plus data-icon="inline-start" />
                {t(WIDGET_REGISTRY[type].title)}
              </Button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AddWidgetList;
